import styled from '@emotion/styled';
import { tokens, Icon } from '@hotjar/hotsauce';
import type { ReactionStyle } from '@hotjar/feedback';
import { FeedbackIcon } from '../FeedbackIcon/FeedbackIcon';

const StyledIcon = styled(Icon)`
  flex-shrink: 0;
`;

const StarIcon = styled(StyledIcon)`
  fill: ${tokens.color.lemon};
`;

const IconMap: Record<ReactionStyle | 'default', JSX.Element> = {
  default: <FeedbackIcon icon="like_buddy_alternate" />,
  emoji: <FeedbackIcon icon="like_emoji" />,
  smiley: <StyledIcon icon="like_smiley" />,
  star: <StarIcon icon="star_filled" />,
};

export const ReactionIcon = ({ reactionStyle }: { reactionStyle: ReactionStyle }): JSX.Element => {
  return IconMap[reactionStyle];
};
